import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/usersDashboard");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.checkCircle}>
          <div style={styles.check}>✓</div>
        </div>

        <h1 style={styles.title}>Payment Successful</h1>

        <p style={styles.message}>
          Your payment has been completed successfully.
        </p>

        <div style={styles.infoBox}>
          <div style={styles.row}>
            <span>Status</span>
            <span style={styles.success}>SUCCESS</span>
          </div>

          <div style={styles.row}>
            <span>Payment Mode</span>
            <span>UPI</span>
          </div>

          <div style={styles.row}>
            <span>Reference</span>
            <span>#TXN{Date.now()}</span>
          </div>
        </div>

        <button
          style={styles.button}
          onClick={() => navigate("/usersDashboard")}
        >
          Go to Dashboard
        </button>

        <p style={styles.redirect}>Redirecting automatically in 3 seconds...</p>
      </div>
    </div>
  );
}

export default PaymentSuccess;

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f8fb",
    fontFamily: "Segoe UI",
  },

  card: {
    width: "420px",
    background: "#fff",
    borderRadius: "18px",
    padding: "40px",
    textAlign: "center",
    boxShadow: "0 15px 40px rgba(0,0,0,.12)",
  },

  checkCircle: {
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    background: "#16a34a",
    margin: "0 auto 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  check: {
    color: "#fff",
    fontSize: "42px",
    fontWeight: "bold",
  },

  title: {
    color: "#16a34a",
    marginBottom: "10px",
  },

  message: {
    color: "#64748b",
    marginBottom: "30px",
  },

  infoBox: {
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "18px",
    marginBottom: "25px",
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #f1f5f9",
  },

  success: {
    color: "#16a34a",
    fontWeight: "700",
  },

  button: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "10px",
    background: "#2563eb",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
  },

  redirect: {
    marginTop: "18px",
    color: "#64748b",
    fontSize: "14px",
  },
};
